import { FC } from 'react';
import ProCheckbox, { CheckboxProps } from './checkbox';
import ProCheckboxGroup, { CheckboxGroupProps } from './group';

export type ICheckboxComponent = FC<
  CheckboxProps & React.RefAttributes<HTMLElement>
> & {
  Group: FC<CheckboxGroupProps>;
};

const TransCheckbox = ProCheckbox as ICheckboxComponent;
TransCheckbox.Group = ProCheckboxGroup;

export default TransCheckbox;
